import { CREATE_AIRPORT_V2, CREATE_AIRPORT_V2_SUCCESS, CREATE_AIRPORT_V2_ERROR, CREATE_AIRPORT_V2_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateAirportV2 = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_AIRPORT_V2:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_AIRPORT_V2_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_AIRPORT_V2_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_AIRPORT_V2_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateAirportV2;
